module.exports = __webpack_public_path__ + "static/media/heart-outline-icon.a6f2c907.svg";